export { default } from './deprecatedPropType';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/deprecatedPropType/index.js
// module id = 832
// module chunks = 25